module.exports = __webpack_public_path__ + "static/media/maz.01160de4.jpeg";